import React from "react";
import CustomizerComponent from "@/bit/components/components.customizer-component";
import Devices from "./carousel";
import Title from "./title";

const DevicesOffers = ({ dispoData, title }) => {
  if (!dispoData) {
    return null;
  }

  return (
    <>
      <section className="device-offers" data-cy="Devices Offers">
        <CustomizerComponent
          name= {title.activityName || "CMS-GP-OFERTAS-DISPOSITIVOS-TITULO"}
          Component={Title}
          componentProps={title}
          componentName="devicesSectionTitle"
        />

        <CustomizerComponent
          name={dispoData.activityName || "CMS-GP-OFERTAS-DISPOSITIVOS"}
          Component={Devices}
          componentProps={dispoData}
          componentName="devicesSection"
          skeletonClassName="skeleton-device-offers-card"
        />
      </section>
      <style jsx>
        {`
          .device-offers {
            padding-top: 1rem;
            padding-bottom: 1rem;            
            :global(h1) {
              letter-spacing: -0.5px;
              line-height: 1.75rem;
            }

            :global(.device-content) {
              padding-top: 1rem;
              padding-bottom: 1rem;
            }
            :global(.carousel-window) {
              gap: 12px;
              :global(.carousel-item-wrapper) {
                padding: 0;
              }
            }
            :global(.mobile) {
              display: block;
            }

            :global(.device-slide) {
              height: 100%;
            }

            :global(.card) {
              padding: 1rem;

              align-items: stretch;
              width: 12rem;
            }

            :global(.card-container) {
              gap: 1rem;
              align-items: flex-start;
              flex-direction: column;

              :global(.card-container--image) {
                height: auto;
                min-width: 100px;
                padding: 0;

                :global(.image) {
                  height: auto;
                }
              }

              :global(.card-content--price) {
                line-height: 1.25rem;

                :global(.price) {
                  display: inline-block;
                  margin-right: 0.2rem;
                  margin-top: 0.2rem;
                  margin-bottom: 0.2rem;

                  :global(.price--unity) {
                    padding-left: 0;
                  }
                }

                :global(.price--pre-price) {
                  display: block;
                }
              }

              :global(.card-header) {
                min-height: 4.5rem;

                :global(.card-header--title) {
                  line-height: 1.2rem;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  min-height: 2.5rem;
                }
              }

              :global(.card-content){
                :global(.card-container--label-two){
                  min-height:2rem;
                }
              }

              :global(.card-container--info) {
                gap: 0.7rem;

                :global(.card-container--label--zero) {
                  min-height: 0 !important;

                  :global(.text) {
                    min-height: inherit;
                  }
                }
              }
            }
          }

          @media screen and (min-width: 768px) {
            .device-offers {
              padding-top: 2rem;
              padding-bottom: 2rem;
              :global(.carousel-window) {
                gap: 1rem;
              }

              :global(.card) {
                width: 15rem;
              }
            }
          }

          @media screen and (min-width: 1280px) {
            .device-offers {
              :global(.desktop) {
                display: block;
                padding-top: 1.5rem;
              }

              :global(.card) {
                padding: 1.5rem;

                :global(.offer-progress) {
                  display: block;

                  :global(.offer--text) {
                    display: flex;
                    justify-content: space-between;
                  }
                }
              }

              :global(.card-container) {
                flex-direction: column;

                :global(.card-container--label) {
                  display: block;
                  width: 100%;
                }

                :global(.card-content--price) {
                  :global(.price) {
                    display: inline-block;
                  }
                  :global(.price--pre-price) {
                  }
                }

                :global(.card-header) {
                  gap: 0;

                  :global(.text) {
                    line-height: 1.25rem;
                  }
                }
              }
            }
          }
        `}
      </style>
    </>
  );
};

export default DevicesOffers;
